import { action, computed, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import constants from 'Constants';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';



class UsageStore {

  @setter @observable numActiveContacts;
  @setter @observable avgNumActiveContacts;
  @setter @observable numProducts;
  @setter @observable monthlyProcessedOrders;

  @setter @observable aovProgressBarPageviews;
  @setter @observable backInStockOverallEmailSends;
  @setter @observable recommenderPageviews;
  @setter @observable promptPopupViews;

  @setter @observable marketingPlatformEmailSends;
  @setter @observable marketingPlatformEmailTransit;

  @setter @observable backInStockEmailSends;
  @setter @observable backInStockEmailTransit;

  @setter @observable reviewsEmailSends;
  @setter @observable reviewsEmailTransit;

  @setter @observable reperksEmailSends;
  @setter @observable reperksEmailTransit;

  @setter @observable emailSends;
  @setter @observable emailTransit;

  static create(data={}) {
    const instance = new UsageStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "numActiveContacts": 0,
      "avgNumActiveContacts": 0,
      "numProducts": 0,
      "monthlyProcessedOrders": 0,

      "aovProgressBarPageviews": 0,
      "backInStockOverallEmailSends": 0,
      "recommenderPageviews": 0,
      "promptPopupViews": 0,

      "marketingPlatformEmailSends": 0,
      "marketingPlatformEmailTransit": 0,

      "backInStockEmailSends": 0,
      "backInStockEmailTransit": 0,

      "reviewsEmailSends": 0,
      "reviewsEmailTransit": 0,

      "reperksEmailSends": 0,
      "reperksEmailTransit": 0,

      "emailSends": 0,
      "emailTransit": 0,
    };
  }

  constructor(defaults=UsageStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=UsageStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "numActiveContacts", "accessor": "num_active_contacts"},
      {"field": "avgNumActiveContacts", "accessor": "avg_num_active_contacts"},
      {"field": "numProducts", "accessor": "num_products"},
      {"field": "monthlyProcessedOrders", "accessor": "monthly_processed_orders"},

      {"field": "aovProgressBarPageviews", "accessor": "aovprogressbar_pageviews"},
      {"field": "backInStockOverallEmailSends", "accessor": "backinstock_overall_email_sends"},
      {"field": "recommenderPageviews", "accessor": "recommender_pageviews"},
      {"field": "promptPopupViews", "accessor": "prompt_popup_views"},

      {"field": "marketingPlatformEmailSends", "accessor": "marketingplatform_email_sends"},
      {"field": "marketingPlatformEmailTransit", "accessor": "marketingplatform_email_transit"},

      {"field": "backInStockEmailSends", "accessor": "backinstock_email_sends"},
      {"field": "backInStockEmailTransit", "accessor": "backinstock_email_transit"},

      {"field": "reviewsEmailSends", "accessor": "reviews_email_sends"},
      {"field": "reviewsEmailTransit", "accessor": "reviews_email_transit"},

      {"field": "reperksEmailSends", "accessor": "reperks_email_sends"},
      {"field": "reperksEmailTransit", "accessor": "reperks_email_transit"},

      {"field": "emailSends", "accessor": "email_sends"},
      {"field": "emailTransit", "accessor": "email_transit"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }
}


export default UsageStore;
